import {
  LuArrowDown, LuArrowUp, LuArrowLeftRight, LuArrowLeftFromLine, LuArrowRightToLine, LuArrowLeftToLine,
} from 'react-icons/lu';
import { VscSymbolInterface } from 'react-icons/vsc';

export const FlowInGlyph = () => <LuArrowDown />;
export const FlowOutGlyph = () => <LuArrowDown />;
export const DataGlyph = () => <LuArrowLeftRight />;
export const ProviderGlyph = () => <VscSymbolInterface />;
export const ArrowLeftGlyph = () => <LuArrowLeftFromLine />;
export const ArrowRightGlyph = () => <LuArrowRightToLine />;
// A left-pointing "to line" arrow — an INCOMING connector that still points left (used where both
// connectors should read left, e.g. the mission graph's dependency handles).
export const ArrowLeftToLineGlyph = () => <LuArrowLeftToLine />;
export const FlowUpGlyph = () => <LuArrowUp />;
